// frontend/src/services/master-data.service.ts
import axios from "axios";

export interface MasterRecord {
  id: string;
  name: string;
  code?: string;
  isActive?: boolean;
}

export interface SessionRecord {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
}

export interface ClassRecord {
  id: string;
  name: string;
  code?: string;
  sequenceOrder: number;
  isActive: boolean;
}

export interface SectionRecord {
  id: string;
  name: string;
  classId?: string;
  sequenceOrder: number;
  isActive: boolean;
}

export const masterDataService = {
  getCastes: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/castes");
    return response.data;
  },
  getReligions: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/religions");
    return response.data;
  },
  getCategories: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/categories");
    return response.data;
  },
  getBloodGroups: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/blood-groups");
    return response.data;
  },
  getExamBoards: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/exam-boards");
    return response.data;
  },
  getHouses: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/houses");
    return response.data;
  },
  getParentServiceTypes: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/parent-service-types");
    return response.data;
  },
  getFamilyRelations: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/family-relations");
    return response.data;
  },
  getDocuments: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/documents");
    return response.data;
  },
  getNationalities: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/nationalities");
    return response.data;
  },
  getMotherTongues: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/mother-tongues");
    return response.data;
  },
  getStudentTypes: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/student-types");
    return response.data;
  },
  getMediums: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/mediums");
    return response.data;
  },
  getLeavingReasons: async () => {
    const response = await axios.get<MasterRecord[]>("/system-settings/masters/leaving-reasons");
    return response.data;
  },
  // Fetches only the currently active academic session
  getActiveSession: async () => {
    const response = await axios.get<SessionRecord>("/system-settings/academic-sessions/active");
    return response.data;
  },
  // Fetches all academic sessions
  getAllSessions: async () => {
    const response = await axios.get<SessionRecord[]>("/system-settings/academic-sessions");
    return response.data;
  },
  getClasses: async () => {
    const response = await axios.get<ClassRecord[]>("/system-settings/classes");
    return response.data;
  },
  getSections: async (classId: string) => {
    const response = await axios.get<SectionRecord[]>(`/system-settings/classes/${classId}/sections`);
    return response.data;
  },
};
